import { api } from './client';
import type { LoginResponse, User } from '@/types';

export function login(email: string, password: string): Promise<LoginResponse> {
  return api<LoginResponse>('/api/auth/login', {
    method: 'POST',
    body: { email, password },
  });
}

export function logout(): Promise<void> {
  return api<void>('/api/auth/logout', { method: 'POST' });
}

export function me(): Promise<User> {
  return api<User>('/api/users/me');
}

export interface AgentLoginResponse {
  agent_token: string;
  key_id: string;
  prefix: string;
  device_label: string;
}

export function agentLogin(
  email: string,
  password: string,
  device_label: string,
): Promise<AgentLoginResponse> {
  return api<AgentLoginResponse>('/api/auth/agent-login', {
    method: 'POST',
    body: { email, password, device_label },
  });
}
